import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';

import {
  GetServicesQuery,
  GetServicesResponse,
} from '@hud/portal-dtos/webapp-service.dto';
import { PORTAL_BASE } from '../consts';

export const SERVICES_ID = 'services';

export default function useServices(params: GetServicesQuery) {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [SERVICES_ID, params],
    queryFn: async () => {
      const response = await client.get<GetServicesResponse>(
        `${PORTAL_BASE}/services`,
        {
          params,
        },
      );
      return GetServicesResponse.parse(response.data);
    },
    enabled: isReady && params?.environmentName !== undefined,
  });
}
